import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/quality/info',
    name: 'qualityInfoGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
